/**
 * Full-container loading overlay while PAYR.init() prepares checkout (API, WorldPay, UI).
 */

import { renderCenteredLoading } from './payrCenteredLoadingShell.js';

const ATTR = 'data-payr-init-loading';
const SET_RELATIVE_FLAG = 'data-payr-init-loading-relative';
const STYLES_ID = 'payr-sdk-init-loading-styles';

function injectStyles(): void {
  if (typeof document === 'undefined') return;
  let s = document.getElementById(STYLES_ID) as HTMLStyleElement | null;
  if (!s) {
    s = document.createElement('style');
    s.id = STYLES_ID;
    document.head.appendChild(s);
  }
  s.textContent = `
    [${ATTR}] {
      position: absolute;
      inset: 0;
      z-index: 20;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 10rem;
      background: #f8fafc;
      border-radius: inherit;
      box-sizing: border-box;
    }
  `;
}

/**
 * Show centered loading UI on top of the partner mount. Safe to call multiple times (replaces prior).
 */
export function showSdkInitLoading(containerElement: HTMLElement): void {
  if (typeof document === 'undefined') return;
  removeSdkInitLoading(containerElement);
  injectStyles();

  const cs = globalThis.getComputedStyle(containerElement);
  if (cs.position === 'static') {
    containerElement.style.position = 'relative';
    containerElement.setAttribute(SET_RELATIVE_FLAG, 'true');
  }

  const wrap = document.createElement('div');
  wrap.setAttribute(ATTR, 'true');
  wrap.setAttribute('role', 'status');
  wrap.setAttribute('aria-live', 'polite');
  wrap.setAttribute('aria-busy', 'true');

  const host = document.createElement('div');
  wrap.appendChild(host);
  renderCenteredLoading(host, {
    title: 'Loading checkout',
    subtitle: 'Setting up payment components…',
    variant: 'verifyingPage',
  });

  containerElement.appendChild(wrap);
}

/** Remove loading overlay and restore container position if the SDK set it. */
export function removeSdkInitLoading(containerElement: HTMLElement): void {
  containerElement.querySelector(`[${ATTR}]`)?.remove();
  if (containerElement.getAttribute(SET_RELATIVE_FLAG) === 'true') {
    containerElement.style.position = '';
    containerElement.removeAttribute(SET_RELATIVE_FLAG);
  }
}
